export const BROWSE_PAGE_OPEN_URL = '/investment-opportunities';
export const BROWSE_PAGE_CLOSED_URL = '/past-investments';
